import { render } from "./JobDetailsCard.vue?vue&type=template&id=3aab9c8a"
import script from "./JobDetailsCard.vue?vue&type=script&lang=js"
export * from "./JobDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__